
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 teachstack-wave-bg">
      <div className="text-center bg-white/80 backdrop-blur-sm p-10 rounded-xl shadow-sm border border-gray-100 max-w-md animate-fade-in">
        <h1 className="text-7xl font-bold text-teachstack-purple mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Oops! This page seems to be missing</p>
        <Button className="bg-teachstack-purple hover:bg-teachstack-purple/90" asChild>
          <a href="/" className="flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Return to Home
          </a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
